// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2UkO5","title":"Info_title__3_vsc","links":"Info_links__33yf9","link":"Info_link__13hWQ","logo":"Info_logo__3oQeP"};